import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getTaxRates(params) {
    return axios.get(adminPath('/tax_rates?') + prepareQueryString(params)).then((response) => {
      return {
        taxRates: response.data.map((taxRate) => an('TaxRate', taxRate)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  getRecurringChargeTaxRates(id, params) {
    return axios.get(adminPath(`/recurring_charges/${id}/tax_rates?`) + prepareQueryString(params)).then((response) => {
      return {
        taxRates: response.data.map((taxRate) => an('TaxRate', taxRate)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  getWorkOrderChargeTaxRates(id, params) {
    return axios.get(adminPath(`/work_order_charges/${id}/tax_rates?`) + prepareQueryString(params)).then((response) => {
      return {
        taxRates: response.data.map((taxRate) => an('TaxRate', taxRate)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  getQuoteItemsTaxRates(id, params) {
    return axios.get(adminPath(`/quote_items/${id}/tax_rates?`) + prepareQueryString(params)).then((response) => {
      return {
        taxRates: response.data.map((taxRate) => an('TaxRate', taxRate)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  get(id) {
    return axios.get(adminPath(`/tax_rates/${id}`)).then((response) => an('TaxRate', response.data));
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/tax_rates/${id}`), {
        ...data,
      })
      .then((response) => an('TaxRate', response.data));
  },
  create(data) {
    return axios
      .post(adminPath('/tax_rates'), {
        ...data,
      })
      .then((response) => an('TaxRate', response.data));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/tax_rates.csv?') + prepareQueryString(params), { responseType: 'blob' });
  },
};
